import { type ColumnPreference, condensedColumns } from '@fv/models'

import { useAppPreferences } from '../settings/user-preferences/hooks'
import { defaultColumnPreferences } from './columns'

export const useColumnPreferences = () => {
  const preferences = useAppPreferences()

  return fillInMissingColumns(
    removeInvalidColumns(
      preferences?.condensedColumns ?? defaultColumnPreferences,
    ),
  )
}

export const removeInvalidColumns = (
  columns: ColumnPreference[],
): ColumnPreference[] => {
  return columns.filter(col => condensedColumns.includes(col.id))
}

const fillInMissingColumns = (
  columns: ColumnPreference[],
): ColumnPreference[] => {
  const columnKeys = columns.map(({ id }) => id)
  const currentColumns = [...columns]
  const missingColumns = condensedColumns
    .filter(col => !columnKeys.includes(col))
    .map(id => ({ id, visible: false }))
  return [...currentColumns, ...missingColumns]
}
